import type { LucideIcon } from "lucide-react";

import { Button } from "@/components/ui/button";

type FloatingButtonProps = {
  icon: LucideIcon;
  onClick?: () => void;
  /** Accessible name for the icon-only action. */
  ariaLabel?: string;
  className?: string;
};

export const FloatingButton: React.FC<FloatingButtonProps> = ({
  icon: Icon,
  onClick,
  ariaLabel = "Ajouter",
  className = "",
}) => {
  return (
    <Button
      onClick={onClick}
      aria-label={ariaLabel}
      size="icon"
      style={{ bottom: "calc(5rem + env(safe-area-inset-bottom))" }}
      className={`
            fixed
            right-6
            h-14 w-14
            rounded-full
            shadow-lg
            hover:scale-105
            transition
            ${className}
        `}
    >
      <Icon size={24} />
    </Button>
  );
};
